import React from "react";
import { WHY_CHOOSE } from "../../data/content";
import { Reveal, Overline } from "../shared/Primitives";
import { DotGrid, Sprig } from "../shared/Decor";

export const WhyChoose = () => {
  return (
    <section id="por-que" data-testid="why-section" className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-28">
      <DotGrid className="absolute top-12 right-8 w-28 text-camel/30 hidden sm:block" />
      <Sprig className="absolute -bottom-6 left-2 w-20 text-camel/25 hidden lg:block" />
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Sticky heading */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <Reveal>
                <Overline>Nuestra propuesta</Overline>
              </Reveal>
              <Reveal delay={0.05}>
                <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-black leading-tight">
                  ¿Por qué elegir<br />COLLECTIVE CO LIVING?
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="mt-6 max-w-md text-base sm:text-lg font-light text-black/60 leading-relaxed">
                  Un modelo de vivienda compartida pensado para profesionistas que
                  buscan calidad, formalidad y comunidad, respaldado por una firma
                  de inversión profesional.
                </p>
              </Reveal>
            </div>
          </div>

          {/* Value props */}
          <div className="lg:col-span-7">
            <div className="divide-y divide-[#B2967D]/30">
              {WHY_CHOOSE.map((item, i) => (
                <Reveal key={item.number} delay={i * 0.08}>
                  <div
                    data-testid={`why-item-${i}`}
                    className="group flex gap-6 sm:gap-10 py-8 sm:py-10 first:pt-0"
                  >
                    <span className="text-sm font-bold text-[#B2967D] pt-1 w-10 shrink-0 transition-colors group-hover:text-[#7D5A44]">
                      {item.number}
                    </span>
                    <div>
                      <h3 className="text-xl sm:text-2xl font-bold text-black">{item.title}</h3>
                      <p className="mt-3 text-lg font-light text-black/60 leading-relaxed">
                        {item.text}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
